import { AbTestVariant } from '~/models/AbTest/AbTest'

export default () => {
    return useCookie<AbTestVariant[]>('abTests', {
        maxAge: 2592000, // 30 days
        secure: true,
    })
}

/**
 * Removes the `abTests` cookie and its localStorage mirror. Called when analytics
 * consent is revoked — A/B testing is a non-essential (analytics) storage, so its
 * persistent identifier must not linger without consent.
 */
export function clearAbTestCookie(): void {
    useCookie('abTests').value = null
    if (typeof localStorage !== 'undefined') {
        localStorage.removeItem('abTests')
    }
}
